import UserMedalTag from './src/main';

UserMedalTag.install = function(Vue) {
  Vue.component(UserMedalTag.name, UserMedalTag);
};

export default UserMedalTag;
